import { cn } from '../../lib/cn';

type Props = {
  message?: string;
  queuedActions?: number;
  className?: string;
};

export function OfflineIndicator({
  message = 'You are offline — changes will sync when connected',
  queuedActions = 0,
  className,
}: Props) {
  return (
    <div
      className={cn(
        'rounded-lg border border-warning-200 bg-warning-50 px-4 py-2 text-sm text-warning-800 dark:border-warning-900 dark:bg-warning-950 dark:text-warning-200',
        className,
      )}
      role="alert"
    >
      {message}
      {queuedActions > 0 && (
        <span className="ml-2 text-xs">({queuedActions} queued)</span>
      )}
    </div>
  );
}
